<template>
  <v-menu
    v-model="menu"
    bottom
    origin="center center"
    transition="scale-transition"
    offset-y
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="fullName"
        label="ФИО водителя"
        readonly
        hide-details
        outline
        height="44"
        class="my-2 ml-2"
        :disabled="disabled"
      >
        <template v-slot:append>
          <slot name="append-content">
            <v-layout>
              <v-spacer />
              <v-icon
                small
                :disabled="disabled"
                v-on="on"
                @click="menu=true"
              >
                edit
              </v-icon>
            </v-layout>
          </slot>
        </template>
      </v-text-field>
    </template>
    <v-card>
      <v-card-title class="subheading pb-2">
        Редактирование ФИО водителя
      </v-card-title>
      <v-card-text class="pt-0 pb-3">
        <v-form v-model="isValid">
          <v-text-field
            v-model="surname"
            label="Фамилия*"
            :required="true"
            :rules="[v => !!v || '']"
            hide-details
            outline
            height="44"
            clearable
            class="my-2"
            @input="isChanged=true"
          />
          <v-text-field
            v-model="name"
            label="Имя*"
            :required="true"
            :rules="[v => !!v || '']"
            hide-details
            outline
            height="44"
            clearable
            class="my-2"
            @input="isChanged=true"
          />
          <v-text-field
            v-model="middlename"
            label="Отчество"
            hide-details
            outline
            height="44"
            clearable
            class="my-2"
            @input="isChanged=true"
          />
          <v-layout>
            <v-spacer />
            <v-btn
              small
              class="primary mx-0 mt-3"
              :disabled="!(isValid && isChanged)"
              @click="apply"
            >
              Ok
            </v-btn>
            <v-btn
              small
              class="mr-0 mt-3"
              @click="cancel"
            >
              Отмена
            </v-btn>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  props: ["value", "disabled"],
  data() {
    return {
      menu: false,
      isValid: false,
      isChanged: false,
      surname: "",
      name: "",
      middlename: "",
    };
  },
  computed: {
    fullName() {
      if (!this.value) {
        return "";
      }
      return `${this.value.surname} ${this.value.name} ${this.value.middlename}`;
    },
  },
  watch: {
    value: {
      handler() {
        this.setDriver(this.value);
      },
      immediate: true,
    },
    menu() {
      this.setDriver(this.value);
    },
  },
  methods: {
    setDriver(value) {
      if (!value) {
        this.surname = "";
        this.name = "";
        this.middlename = "";
        return;
      }
      this.surname = value.surname;
      this.name = value.name;
      this.middlename = value.middlename;
    },
    apply() {
      this.isChanged = false;
      this.menu = false;
      const driver = {
        surname: `${this.surname.charAt(0).toUpperCase()}${this.surname.slice(
          1,
        )}`,
        name: `${this.name.charAt(0).toUpperCase()}${this.name.slice(1)}`,
        middlename: `${this.middlename
          .charAt(0)
          .toUpperCase()}${this.middlename.slice(1)}`,
      };
      return this.$emit("change", driver);
    },
    cancel() {
      this.isChanged = false;
      this.menu = false;
    },
  },
};
</script>